import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-avatar",
  "use": "icon-avatar-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-avatar\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 384m-192 0a192 192 0 1 0 384 0 192 192 0 1 0-384 0Z\" p-id=\"9886\" /><path d=\"M512 592.64a320 320 0 0 0-320 320h640a320 320 0 0 0-320-320z\" p-id=\"9887\" /><path d=\"M890.88 128a5.12 5.12 0 0 1 5.12 5.12v757.76a5.12 5.12 0 0 1-5.12 5.12H133.12a5.12 5.12 0 0 1-5.12-5.12V133.12A5.12 5.12 0 0 1 133.12 128h757.76m0-64H133.12A69.12 69.12 0 0 0 64 133.12v757.76A69.12 69.12 0 0 0 133.12 960h757.76A69.12 69.12 0 0 0 960 890.88V133.12A69.12 69.12 0 0 0 890.88 64z\" p-id=\"9888\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/avatar.svg
// module id = SlSe
// module chunks = 3